export default __webpack_public_path__ + "static/media/bolster.f6029c05.webp";